import * as Yup from "yup";

export const SignUpValidation = Yup.object().shape({
  password: Yup.string()
    .required("password is required")
    .matches(/(?=.*[a-z])/, "Password must contain a lowercase letter")
    .matches(/(?=.*[A-Z])/, "Password must contain an uppercase letter")
    .matches(/(?=.*[0-9])/, "Password must contain a number")
    .matches(/(?=.[!@#$%^&])/, "Password must contain a special character")
    .min(8, "Password must be at least 8 characters"),

  phoneNumber: Yup.string()
    .required()
    .length(11, "Phone number must be least 11 characters"),
  confirmPassword: Yup.string()
    .required("Confirm Password is required")
    .oneOf([Yup.ref("password")], "Passwords must match"),
  email: Yup.string()
    .required("Please enter your email address")
    .email("Please enter a valid email address"),
  firstName: Yup.string().required("Please enter your first name"),
  lastName: Yup.string().required("Please enter your last name"),
  address: Yup.string().required("Please enter your address"),
});

export const otpValidation = Yup.object().shape({
  otp: Yup.string()
    .required("Otp is required")
    .min(6, "Otp must be 6 characters"),
});
export const emailValidation = Yup.object().shape({
  emailOrPhoneNumber: Yup.string().required("email or phoneNumber is required"),
  password: Yup.string().required("password is required"),
});

export const ChangePasswordValidation = Yup.object().shape({
  oldPassword: Yup.string().required("password is required"),
  newPassword: Yup.string()
    .required("Confirm Password is required")
    .matches(/(?=.*[a-z])/, "Password must contain a lowercase letter")
    .matches(/(?=.*[A-Z])/, "Password must contain an uppercase letter")
    .matches(/(?=.*[0-9])/, "Password must contain a number")
    .matches(/(?=.[!@#$%^&])/, "Password must contain a special character")
    .min(8, "Password must be at least 8 characters"),
});

export type otpOnlyForm = Yup.InferType<typeof otpValidation>;
export type emailOnlyForm = Yup.InferType<typeof emailValidation>;
export type SignUpForm = Yup.InferType<typeof SignUpValidation>;
export type changePasswordForm = Yup.InferType<typeof ChangePasswordValidation>;
